export default "__VITE_ASSET__Co2fjw44__"